import { faArrowLeft as ArrowLeftIcon } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { useColorScheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useAtom } from 'jotai';
import { capitalize } from 'lodash';
import { useNavigate } from 'react-router';

import VMPGenericChip from '@/components/VMPGenericChip';
import selectedVulnerabilityAtom from '@/pages/VulnerabilityManagement/VMPVulnerabilities/VMPVulnerabilities.store';
import { isLayoutMobileAtom } from '@/store/layout';

import useStyles from './VulnerabilityDetailsSubTopBar.styles';

const VulnerabilityDetailsSubTopbarTop = () => {
  const [isLayoutMobile] = useAtom(isLayoutMobileAtom);
  const [{ name, cvss, vulnerability_name, cvss_level }] = useAtom(
    selectedVulnerabilityAtom
  );
  const { mode: themeMode } = useColorScheme();
  const { classes } = useStyles({ isLayoutMobile, themeMode });
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  const severityLevel = cvss_level || 'N/A';

  return (
    <Stack direction="row">
      <Button
        onClick={handleBack}
        color="secondary"
        className={classes.backButtonContainer}
      >
        <FontAwesomeIcon icon={ArrowLeftIcon} size="lg" />
      </Button>
      <div className={classes.vulnerabilityDetailsSubTopbar}>
        <div className={classes.subTopbarTopContent}>
          <Stack direction="row" sx={{ alignItems: 'start' }} spacing={1}>
            <div>
              <Typography
                variant="h6"
                style={{ display: 'inline', fontWeight: 'normal' }}
              >
                Vulnerability
              </Typography>
              <Typography component="h1" variant="h3">
                {name?.length ? name : vulnerability_name}
              </Typography>
              <div style={{ marginTop: '0.25rem' }}>
                <VMPGenericChip
                  value={severityLevel}
                  text={`${cvss} ${capitalize(severityLevel)}`}
                />
              </div>
            </div>
          </Stack>
        </div>
      </div>
    </Stack>
  );
};

export default VulnerabilityDetailsSubTopbarTop;
